<template>
    <section>
      <el-select v-model="proId" placeholder="请选择项目" @change="proChange()">
        <el-option v-for="(item,index) in proList" :key="item.id" :value="item.id"
                   :label="item.proName"></el-option>
      </el-select>
    </section>
</template>

<script>
    export default {
        name: "ProjectList",
        data(){
          return {
              proId:null,//绑定的项目数据
              proList:[],//项目集合
          }
        },
        methods:{
          proChange:function(){
            this.$cookies.set("project", this.proId);
            this.$emit('proSelected',this.proId);
          }
        },
        mounted() {
          this.proList = this.GLOBAL.proList;
          let project = this.$cookies.get("project");
          if(project=='null' || project==null || 'NaN' == project || project == ''){
              this.proId = this.proList[0].id;
          }else {
              this.proId = parseInt(project);
          }
          this.$emit('proSelected',this.proId);
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/command/ProjectList.vue